import cookies from 'js-cookie';

export default (visitorId) => {
  const expires = new Date(new Date().setYear(3017));
  cookies.set('visitorId', visitorId, { expires });
};
